// 操作列只改变显示尺寸，不改列数据、插槽、权限或事件。
import { ref, watch, onMounted, onUpdated, onBeforeUnmount, type Ref } from 'vue'
import type { AdaptiveColumn } from './responsiveTable'
export const actionColumnKey = (column:AdaptiveColumn):string => {
 const field=Array.isArray(column.dataIndex)?column.dataIndex.join('.'):String(column.dataIndex || column.key || column.title || '')
 return field==='subcommand'?'command':field
}
export const isActionColumn = (column:AdaptiveColumn):boolean => /^(commands?|subcommand|operate|operations?|actions?|refound|delete|view)$/i.test(actionColumnKey(column)) || /^(操作|执行|删除|查看|编辑|Actions?|Operations?)$/i.test(String(column.title || '').trim())
export function fitActionColumns<T extends AdaptiveColumn>(columns:T[], widths:Record<string,number>):T[] {
 return columns.map(column=>column.children?.length?{...column,children:fitActionColumns(column.children,widths)} as T:isActionColumn(column)
  ? {...column,fixed:'right',width:widths[actionColumnKey(column)] || 80,minWidth:widths[actionColumnKey(column)] || 80,maxWidth:widths[actionColumnKey(column)] || 80,flex:0} as T:column)
}
export function useActionColumns(root:Ref<HTMLElement|null|undefined>,enabled:()=>boolean=()=>true) {
 const widths=ref<Record<string,number>>({})
 let frame=0,resize:ResizeObserver|undefined,mutation:MutationObserver|undefined,stopped=false
 const nodes=()=>Array.from(root.value?.querySelectorAll<HTMLElement>('.admin-action-content[data-action-key]') || []).filter(node=>node.closest('[data-action-scope]')===root.value)
 const measure=()=>{
  frame=0
  if(stopped || !enabled() || !root.value?.getClientRects().length)return
  const next:Record<string,number>={}
  for(const node of nodes()) {
   if(!node.getClientRects().length)continue
   const cell=node.closest('td'),style=cell?getComputedStyle(cell):null,margin=getComputedStyle(node)
   const padding=parseFloat(style?.paddingLeft || '0')+parseFloat(style?.paddingRight || '0')+parseFloat(margin.marginLeft || '0')+parseFloat(margin.marginRight || '0')+4
   const key=node.dataset.actionKey!
   next[key]=Math.max(next[key] || 80,Math.ceil(Math.max(node.scrollWidth,node.getBoundingClientRect().width)+padding))
  }
  if(JSON.stringify(next)!==JSON.stringify(widths.value))widths.value=next
 }
 const schedule=()=>{if(!stopped && enabled() && !frame)frame=requestAnimationFrame(measure)}
 const observe=()=>{resize?.disconnect();nodes().forEach(node=>resize?.observe(node));schedule()}
 onMounted(()=>{
  if(typeof ResizeObserver!=='undefined')resize=new ResizeObserver(schedule)
  if(typeof MutationObserver!=='undefined' && root.value){mutation=new MutationObserver(observe);mutation.observe(root.value,{subtree:true,childList:true,characterData:true})}
  observe();window.addEventListener('resize',schedule)
 })
 onUpdated(observe);watch(enabled,schedule)
 onBeforeUnmount(()=>{stopped=true;cancelAnimationFrame(frame);resize?.disconnect();mutation?.disconnect();window.removeEventListener('resize',schedule)})
 return {widths,isActionColumn,actionColumnKey}
}
